<template>
  <div v-if="loaded"
       class="million-read-user-center"
       v-ym-report:MILLION_VIP_USER_HOMEPAGE_EXPOSURE=""
  >
    <div class="million-read-user-center-header">
      <div class="million-read-user-center-header-bar"
      >
        <header-back-btn />
        <ym-icon class="share-icon"
                 name="mr-share"
                 v-ym-report:MILLION_VIP_USER_HOMEPAGE_SHARE_CLICK="{
                   userId: userId,
                 }"
                 @click="handleShowShare"
        />
      </div>
      <div v-if="userInfo"
           class="million-read-user-center-header-user-info"
      >
        <ym-img class="million-read-user-center-header-user-avatar"
                :src="userInfo.avatar"
        />
        <div class="million-read-user-center-header-user-name">
          {{ userInfo.name }}
        </div>
        <div class="million-read-user-center-header-user-gender-grade">
          <template v-if="userInfo.gender && userInfo.gender !== ''">
            {{ userInfo.gender }}
          </template>
          <template v-if="userInfo.grade && userInfo.grade !== ''">
            ，{{ userInfo.grade }}
          </template>
        </div>
      </div>
      <div v-if="userInfo.signature && userInfo.signature !== ''"
           class="million-read-user-center-header-user-signature"
      >
        {{ userInfo.signature }}
      </div>
    </div>
    <div v-if="userInfo && userInfo.count"
         class="million-read-user-center-detail-info"
    >
      <div class="million-read-user-center-detail-info-item">
        <div class="million-read-user-center-detail-info-item-value">
          {{ userInfo.count.learn }} <span>万字</span>
        </div>
        <div class="million-read-user-center-detail-info-item-title">
          累计阅读
        </div>
      </div>
      <div class="million-read-user-center-detail-info-item">
        <div class="million-read-user-center-detail-info-item-value">
          {{ userInfo.count.like }}
        </div>
        <div class="million-read-user-center-detail-info-item-title">
          作品收到的赞
        </div>
      </div>
      <div class="million-read-user-center-detail-info-item">
        <div class="million-read-user-center-detail-info-item-value">
          {{ userInfo.count.work }}
        </div>
        <div class="million-read-user-center-detail-info-item-title">
          上榜作品
        </div>
      </div>
    </div>
    <div v-if="favorite.length !== 0"
         class="million-read-user-center-favorite"
    >
      <div class="million-read-user-center-favorite-tab">
        <div class="million-read-user-center-favorite-tab-item"
             :class="{ 'active': currFavoriteIndex === tabIndex }"
             v-for="(tab, tabIndex) in favorite"
             :key="tabIndex"
             @click="handleClickFavoriteTab(tabIndex)"
        >
          {{ formatFavoriteTabTitle(tab.type, tab.count) }}
        </div>
      </div>
      <div class="million-read-user-center-favorite-list">
        <div class="million-read-user-center-favorite-item"
             v-for="(item, index) in favorite"
             :key="index"
        >
          <div v-if="currFavoriteIndex === index"
               class="million-read-user-center-favorite-item-container"
          >
            <div v-if="item.list && item.list.length !== 0"
                 class="million-read-user-center-favorite-item-book-list"
            >
              <div class="million-read-user-center-favorite-item-book-item"
                   v-for="(book, bookIndex) in item.list"
                   :key="bookIndex"
                   @click="handleAudioDetail(book.id)"
              >
                <book-cover class="cover"
                            :cover="book.cover"
                />
                <div class="title ym-two-line-ellipsis">{{ book.summary }}</div>
              </div>
            </div>
            <empty-page v-else
                        type="million-read"
                        model="content"
                        hint="暂无在读书籍"
            />
          </div>
        </div>
      </div>
      <div class="million-read-user-center-favorite-action"
           v-ym-report:MILLION_VIP_USER_HOMEPAGE_BOOK_SHOW_ALL_CLICK="{
             title: formatFavoriteTabTitle(favorite[currFavoriteIndex].type, 0),
           }"
           @click="handleShowMoreFavorite"
      >
        查看书架
      </div>
    </div>
    <div v-if="medal && medal.list.length !== 0"
         class="million-read-user-center-medal"
    >

      <block-title :title="medal.blockTitle"
                   :count="medal.count"
      />
      <div v-if="medal.list && medal.list.length !== 0"
           class="million-read-user-center-medal-list"
      >
        <div class="million-read-user-center-medal-item"
             v-for="(item, index) in medal.list"
             :key="index"
             v-ym-report:MILLION_VIP_USER_MEDAL_ITEM_CLICK="{
               medalId: item.id,
               location: 'homepage',
             }"
             @click="handleMedalDetail(item.id, item.itemId)"
        >
          <img class="million-read-user-center-medal-item-cover"
               :src="item.cover"
          />
          <div class="million-read-user-center-medal-item-title">
            {{ item.title }}
          </div>
        </div>
      </div>
      <div v-if="medal.showMore"
           class="million-read-user-center-medal-action"
           v-ym-report:MILLION_VIP_USER_HOMEPAGE_MEDAL_SHOW_ALL_CLICK=""
           @click="handleShowMoreMedal"
      >
        查看全部勋章
      </div>
    </div>
    <div v-if="certificate && certificate.list.length !== 0"
         class="million-read-user-center-certificate"
    >
      <block-title :title="certificate.blockTitle"
                   :count="certificate.count"
      />
      <div v-if="certificate.list && certificate.list.length !== 0"
           class="million-read-user-center-certificate-list"
      >
        <certificate-item v-for="(item, index) in certificate.list"
                          :key="index"
                          :item="item"
        />
      </div>
      <div v-if="certificate.showMore"
           class="million-read-user-center-certificate-action"
           v-ym-report:MILLION_VIP_USER_HOMEPAGE_CERTIFICATE_SHOW_ALL_CLICK=""
           @click="handleShowMoreCertificate"
      >
        查看全部证书
      </div>
    </div>
    <div v-if="work && work.list.length !== 0"
         class="million-read-user-center-work"
    >
      <block-title :title="work.blockTitle"
                   :count="work.count"
      />
      <div v-if="work.list && work.list.length !== 0"
           class="million-read-user-center-work-list"
      >
        <work-item v-for="(item, index) in work.list"
                   :key="index"
                   :item="item"
                   :curr-user-id="userId"
                   location="homepage"
        />
      </div>
      <div class="million-read-user-center-work-action"
           v-ym-report:MILLION_VIP_USER_WORK_SHOW_ALL_CLICK=""
           @click="handleShowMoreWork"
      >
        查看全部作品
      </div>
    </div>

    <share-mask :show.sync="showShareMask"
                :share-path="$wechat.getWechatMenuShareAppLink()"
                message="请复制下方链接，前往粘贴给好友"
    />
  </div>
</template>

<script>
  import { decorator, before } from 'ym-reporter-vue';
  import { HeaderBackBtn } from '@ymba/ym-ui';
  import BookCover from '@/pages/MillionRead/components/BookCover';
  import EmptyPage from '@/components/EmptyPage';
  import BlockTitle from '@/pages/MillionReadUserCenter/components/BlockTitle';
  import WorkItem from '@/pages/MillionReadUserCenter/components/WorkItem';
  import CertificateItem from '@/pages/MillionReadUserCenter/components/CertificateItem';
  import ShareMask from '@/components/ShareMask';
  import { getUserCenterInfo } from '@/services/million-read';
  import { isAppWebView } from '@/utils';

  export default {
    name: 'MillionReadUserCenter',
    metaInfo: {},
    components: {
      HeaderBackBtn,
      BookCover,
      EmptyPage,
      BlockTitle,
      WorkItem,
      CertificateItem,
      ShareMask,
    },
    data() {
      return {
        loaded: false,
        userInfo: null,
        favorite: null,
        medal: null,
        certificate: null,
        work: null,

        currFavoriteIndex: 0,

        showShareMask: false,
      };
    },
    computed: {
      inAppWebView() {
        return isAppWebView();
      },
      userId() {
        const { $route } = this;
        return $route.query && $route.query.userId ? parseInt($route.query.userId, 10) : 0;
      },
    },
    methods: {
      handleShowShare() {
        this.showShareMask = true;
      },
      async fetchData() {
        const data = await getUserCenterInfo(this.userId);
        this.loaded = data.loaded;
        this.userInfo = data.userInfo;
        this.favorite = data.favorite;
        this.medal = data.medal;
        this.certificate = data.certificate;
        this.work = data.work;
        this.loaded = true;
      },
      formatFavoriteTabTitle(type, count) {
        const countDesc = count === 0 ? '' : `·${count}`;
        if (type === 'recentlyRead') return '最近阅读';
        if (type === 'finishRead') return `读完${countDesc}`;
        return `共同阅读${countDesc}`;
      },
      @decorator(before(function (index) {
        if (index === 0) {
          this.$reporter.report('MILLION_VIP_USER_HOMEPAGE_BOOK_RECENT_CLICK');
          return;
        }
        if (index === 1) {
          this.$reporter.report('MILLION_VIP_USER_HOMEPAGE_BOOK_FINISHED_CLICK');
          return;
        }
        if (index === 2) {
          this.$reporter.report('MILLION_VIP_USER_HOMEPAGE_BOOK_TOGETHER_CLICK');
        }
      }))
      handleClickFavoriteTab(index) {
        this.currFavoriteIndex = index;
      },
      handleAudioDetail(id) {
        console.log('handleAudioDetail', id);
        this.$router.push({
          name: 'MillionReadInterpretBook',
          query: {
            id,
          },
        });
      },
      handleShowMoreFavorite() {
        this.$router.push({
          name: 'MillionReadUserCenterFavorite',
          query: {
            userId: this.userId,
            type: this.favorite[this.currFavoriteIndex].type,
          },
        });
      },
      handleMedalDetail(id, itemId) {
        this.$router.push({
          name: 'MillionReadCollectionMedalDetail',
          params: {
            id,
          },
          query: {
            userId: this.userId,
            itemId,
          },
        });
      },
      handleShowMoreMedal() {
        this.$router.push({
          name: 'MillionReadUserCenterMedal',
          query: {
            userId: this.userId,
          },
        });
      },
      handleShowMoreCertificate() {
        this.$router.push({
          name: 'MillionReadUserCenterCertificate',
          query: {
            userId: this.userId,
          },
        });
      },
      handleShowMoreWork() {
        this.$router.push({
          name: 'MillionReadUserCenterWork',
          query: {
            userId: this.userId,
          },
        });
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-user-center {
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: 110px;
    background: @color-white;

    &-header {
      box-sizing: border-box;
      padding-bottom: 148px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      background: linear-gradient(to bottom, @color-white, #fff8ac);
      &-bar {
        box-sizing: border-box;
        width: 100%;
        height: 88px;
        margin-bottom: 16px;
        padding: 0 @size-base;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .share-icon {
          color: @color-text-base;
          font-size: @font-size-extra-large;
        }
      }
      &-user-avatar {
        width: 150px;
        height: 150px;
        margin-bottom: 32px;
        border-radius: 50%;
        overflow: hidden;
      }
      &-user-name {
        margin-bottom: 16px;
        color: @color-text-base;
        font-size: @font-size-large;
        line-height: 1;
      }
      &-user-gender-grade {
        color: @color-text-light;
        font-size: @font-size-small;
        line-height: 1;
      }
      &-user-signature {
        margin-top: @size-base;
        color: @color-text-base;
        font-size: @font-size-base;
        line-height: 1;
      }
    }
    &-detail-info {
      width: 686px;
      height: 166px;
      margin: -84px auto 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: @color-white;
      box-shadow: 0 1px 10px 0 rgba(176, 158, 79, 0.1);
      border-radius: 16px;
      &-item {
        flex: 1;
        height: 166px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &:not(:last-child) {
          position: relative;
          &:after {
            position: absolute;
            top: 58px;
            right: 0;
            content: '';
            width: 4px;
            height: 48px;
            background: #eee;
          }
        }
        &-value {
          display: flex;
          align-items: flex-end;
          color: @color-text-base;
          font-size: 48px;
          font-weight: @font-weight-strong;
          line-height: 1;
          word-break: keep-all;
          span {
            box-sizing: border-box;
            margin-left: 6px;
            padding-bottom: 5px;
            color: @color-text-light;
            font-size: @font-size-small;
            line-height: 1;
          }
        }
        &-title {
          margin-top: 14px;
          color: @color-text-base;
          font-size: @font-size-small;
          line-height: 1;
        }
      }
    }
    &-favorite {
      margin-bottom: 100px;
      &-tab {
        margin-bottom: 64px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: @border-base;
        &-item {
          box-sizing: border-box;
          flex: 1;
          padding: 24px 0;
          color: @color-text-light;
          font-size: @font-size-base;
          line-height: 1;
          text-align: center;
          &.active {
            position: relative;
            color: #ff8500;
            font-size: @font-size-medium;
            font-weight: @font-weight-strong;
            &:after {
              position: absolute;
              content: '';
              bottom: 0;
              left: calc(50% - 40px);
              width: 80px;
              height: 4px;
              background: #ff8500;
            }
          }
        }
      }
      &-list {
        box-sizing: border-box;
        width: 750px;
        min-height: 370px;
        margin-bottom: @size-base;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }
      &-item-container {
        box-sizing: border-box;
        width: 750px;
        min-height: 370px;
        padding-left: @size-base;
        /deep/ .page-empty-message--content {
          height: 370px;
          .hint {
            margin-top: @size-extra-small;
          }
        }
      }
      &-item-book-list {
        display: flex;
        align-items: center;
      }
      &-item-book-item {
        width: 210px;
        height: 100%;
        &:not(:last-child) {
          margin-right: 28px;
        }
        .cover {
          box-sizing: border-box;
          margin-bottom: @size-extra-small;
          border-radius: 8px;
          overflow: hidden;
          /deep/ img {
            border: @border-base;
          }
        }
        .title {
          min-height: 80px;
        }
      }
      &-action {
        width: 686px;
        height: 88px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-light;
        font-size: @font-size-medium;
        background: @background-color-lighter;
        border-radius: 44px;
      }
    }
    &-medal {
      margin-bottom: 100px;
      &-list {
        box-sizing: border-box;
        margin-bottom: @size-base;
        padding-left: 62px;
        display: flex;
      }
      &-item {
        width: 160px;
        &:not(:last-child) {
          margin-right: 72px;
        }
      }
      &-item-cover {
        width: 160px;
        height: 160px;
        border-radius: 4px;
      }
      &-item-title {
        color: @color-text-base;
        font-size: 26px;
        line-height: 1;
        word-break: keep-all;
      }
      &-action {
        width: 686px;
        height: 88px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-light;
        font-size: @font-size-medium;
        background: @background-color-lighter;
        border-radius: 44px;
      }
    }
    &-certificate {
      margin-bottom: 100px;
      &-list {
        box-sizing: border-box;
        margin-bottom: @size-base;
        padding-left: 80px;
        display: flex;
      }
      &-action {
        width: 686px;
        height: 88px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-light;
        font-size: @font-size-medium;
        background: @background-color-lighter;
        border-radius: 44px;
      }
    }
    &-work {
      &-list {
        width: 686px;
        margin: 0 auto;
      }
      &-action {
        width: 686px;
        height: 88px;
        margin: 48px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-light;
        font-size: @font-size-medium;
        background: @background-color-lighter;
        border-radius: 44px;
      }
    }
  }

</style>
